"use client"

import { useEffect } from "react"
import * as Sentry from "@sentry/nextjs"
import { Button } from "@/components/ui/button"
import { AlertCircle } from "lucide-react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="flex justify-center">
          <AlertCircle className="h-16 w-16 text-destructive" />
        </div>
        <div className="space-y-2">
          <h2 className="text-2xl font-bold">Něco se pokazilo</h2>
          <p className="text-muted-foreground">
            Došlo k neočekávané chybě. Problém jsme zaznamenali a
            pracujeme na nápravě.
          </p>
          {error.digest && (
            <p className="text-xs text-muted-foreground font-mono">
              Kód chyby: {error.digest}
            </p>
          )}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={reset} variant="default">
            Zkusit znovu
          </Button>
          <Button
            onClick={() => (window.location.href = "/")}
            variant="outline"
          >
            Zpět na hlavní stránku
          </Button>
        </div>
      </div>
    </div>
  )
}
